import {currentLocale} from "../index";

export default class Constant {
    static get pionexApkHost() {
        return "https://static.pionex.com";
    }
}
